export let Folders = "PQSf9";
export default {Folders};